export type LegalLinkKey =
  | 'termsOfUse'
  | 'privacyPolicy'
  | 'videoConsentViewingPolicy'
  | 'dmcaNotice'
  | 'doNotSellOrShare';

export type LegalLinkItem = {
  key: LegalLinkKey;
  /** i18n key under common.footer / user.legal */
  labelKey: string;
  url?: string;
};

/** Footer legal link definitions (URLs resolved from Firebase legal_docs) */
export const FOOTER_LEGAL_LINK_DEFS: Omit<LegalLinkItem, 'url'>[] = [
  { key: 'termsOfUse', labelKey: 'terms_of_use' },
  { key: 'privacyPolicy', labelKey: 'privacy_policy' },
  { key: 'videoConsentViewingPolicy', labelKey: 'video_consent_viewing_policy' },
  { key: 'dmcaNotice', labelKey: 'dmca_notice' },
  { key: 'doNotSellOrShare', labelKey: 'do_not_sell_or_share' },
];

/** My Account / Legal page definitions */
export const ACCOUNT_LEGAL_LINK_DEFS: Omit<LegalLinkItem, 'url'>[] = [
  ...FOOTER_LEGAL_LINK_DEFS,
];

export const COOKIE_SETTINGS_EVENT = 'cookie-settings:open';
